import React from "react";
import cvData from "../data/cvData.json";

const Projects = () => {
  const { projects } = cvData;
  const [featuredProject, ...otherProjects] = projects;

  return (
    <section id="projects" className="relative z-10 mx-auto w-full max-w-6xl px-6 py-12">
      <h2 className="section-title">Portfolio &amp; Projects</h2>
      <p className="mt-4 text-sm text-text-secondary">
        Selected projects showcasing full-stack development expertise and problem-solving abilities
      </p>
      <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-3">
        {featuredProject && (
          <div className="glass-card flex h-full flex-col gap-4 p-8 lg:col-span-2" itemProp="knowsAbout" itemScope itemType="https://schema.org/SoftwareApplication">
            <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-cyan-200/80">
              Featured Project
            </div>
            <div className="flex-1">
              <h3 className="text-3xl font-semibold text-white mb-4" itemProp="name">
                {featuredProject.name}
              </h3>
              <p className="text-base text-text-secondary mb-6" itemProp="description">
                {featuredProject.description}
              </p>
            </div>
            <div className="flex flex-wrap gap-2 mb-6">
              {featuredProject.technologies.map((tech, techIndex) => (
                <span key={techIndex} className="glass-chip" itemProp="programmingLanguage">
                  {tech}
                </span>
              ))}
            </div>
            {(featuredProject.link || featuredProject.repo) && (
              <div className="flex flex-wrap gap-3">
                {featuredProject.link && (
                  <a
                    href={featuredProject.link}
                    className="glass-button"
                    target="_blank"
                    rel="noopener noreferrer"
                    itemProp="url"
                    aria-label={`View live demo of ${featuredProject.name}`}
                    title={`View live demo of ${featuredProject.name}`}
                  >
                    Live Demo
                  </a>
                )}
                {featuredProject.repo && (
                  <a
                    href={featuredProject.repo}
                    className="glass-button"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`View ${featuredProject.name} on GitHub`}
                    title={`View ${featuredProject.name} on GitHub`}
                  >
                    GitHub Repo
                  </a>
                )}
              </div>
            )}
          </div>
        )}
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-1">
          {otherProjects.map((project, index) => (
            <div
              key={index}
              className="glass-card flex h-full flex-col p-6 transition-transform duration-200 hover:-translate-y-1"
            >
              <div className="flex-1">
                <h3 className="text-2xl font-semibold text-white mb-3">
                  {project.name}
                </h3>
                <p className="text-sm text-text-secondary mb-5">
                  {project.description}
                </p>
              </div>
              <div className="flex flex-wrap gap-2 mb-6">
                {project.technologies.map((tech, techIndex) => (
                  <span key={techIndex} className="glass-chip">
                    {tech}
                  </span>
                ))}
              </div>
              {(project.link || project.repo) && (
                <div className="flex flex-wrap gap-3">
                  {project.link && (
                    <a
                      href={project.link}
                      className="glass-button"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`View live demo of ${project.name}`}
                      title={`View live demo of ${project.name}`}
                    >
                      Live Demo
                    </a>
                  )}
                  {project.repo && (
                    <a
                      href={project.repo}
                      className="glass-button"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`View ${project.name} on GitHub`}
                      title={`View ${project.name} on GitHub`}
                    >
                      GitHub Repo
                    </a>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
